import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {IcDataService} from "../../services/ic-data.service";
import {FileManagerService} from "../../main/file-manager/file-manager.service";
import {NICEFile} from "../../models/NICE_File.model";

@Component({
    selector: 'submit-transcription-files-dialog',
    templateUrl: './submit-transcription-files-dialog.component.html'
})

export class SubmitTranscriptionFilesDialogComponent implements OnInit {
    completeProgress = 0;
    totalProcessCount = 0;
    currentProcessIndex = 0;
    statusMessage= '';
    hideStopStart= true;
    progressMode = 'determinate';
    processState = 'Discovering Files...';
    processingMessage =''
    processQueue: any[] = [];
    private isCanceled = false;

    constructor(
        private dialogRef: MatDialogRef<SubmitTranscriptionFilesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SaveRecordsDialogModel,
        private icData: IcDataService,
        private _fileManagerService: FileManagerService,
    ) {

    }

    ngOnInit(): void {
        this.findProcessFiles();
    }

    startProcessBatch(startIndex: number): void {
        this.processBatchUpdate(startIndex).then( (processResult) => {
                this.processState = processResult.result;
                this.processingMessage = processResult.message;
            }
        );
    }

    findProcessFiles(){
        this._fileManagerService.getFolderFiles(this.data.records).then((allNiceFiles) => {
            console.log('allNiceFiles',allNiceFiles);
            this.processQueue = allNiceFiles;
            this.processState = 'ConfirmTotal';
            this.totalProcessCount = this.processQueue.length;
            this.processingMessage = 'Process ' + this.totalProcessCount + ' files?';
        }).catch(error => {this.processState='Error'; this.statusMessage=error.statusMessage});
    }

    async processBatchUpdate(startIndex = 0): Promise<any> {
        this.processState = 'Processing';
        this.totalProcessCount = this.processQueue.length;
        for (let _i = startIndex; _i < this.processQueue.length; _i++) {
            if (this.isCanceled){
                return {
                    result: 'Canceled',
                    message: 'Canceled'
                };
            }
            this.hideStopStart = true;
            this.progressMode = 'determinate';
            const file2Submit = this.processQueue[_i];
            this.processingMessage = 'Processing '+ file2Submit.fileNameWithPath;
            this.completeProgress = Math.round((_i + 1) * 100 / this.processQueue.length);
            this.currentProcessIndex = _i;
            try {
                await this.icData.submitFileForTranscription(file2Submit.fileNameWithPath);
            } catch (error) {
                {
                    console.log(error);
                    const icStatusDescription = error.headers.get('icstatusdescription');
                    return {
                        result: 'Results',
                        message: 'Failed to Process ' + error.error?.errors[0]?.message || error.error.error_description + ' - ' + icStatusDescription || ''
                    };
                }

            }
        }
        return {
            result: 'Results',
            message: 'Files Submitted, and will process in the background',
        };
    }

    cancelProcess(): void {
    //    this._fileManagerService.foundFileCount.unsubscribe();
        this.isCanceled = true;
        this.dialogRef.close(false);
    }

    confirm(){
        switch (this.processState) {
            case 'ConfirmTotal': {
                this.startProcessBatch(0);
                break;
            }
            case 'Results': {
                this.dialogRef.close(true);
                break;
            }
        }
    }

}

export class SaveRecordsDialogModel {
    constructor(
        public records: NICEFile[]
    )
    {

    }
}


